// Plain helpers, kept apart from the dialog hook so non-React code (savedCardFlows)
// can read a refusal without importing React contexts.

/** The server's code on a card payment refused for exceeding the travel file's
 *  balance (pelecardChargeGuards.ts). */
export const EXCEEDS_BALANCE_CODE = 'EXCEEDS_BALANCE';

export type OverBalanceInfo = {
    /** What the agent is charging, in the travel file's currency. */
    amount?: number;
    /** What the travel file still owes — 0 when it is paid in full. */
    balance?: number;
    /** What has been paid on the travel file so far. */
    paid?: number;
    /** The travel file's currency code — what both figures are in. */
    currency?: string;
};

/** Reads an over-balance refusal out of a JSON error body; null for anything else. */
export const readOverBalance = (body: unknown): OverBalanceInfo | null => {
    const data = body as {
        code?: unknown;
        amount?: unknown;
        balance?: unknown;
        paid?: unknown;
        currency?: unknown;
    } | null;
    if (!data || data.code !== EXCEEDS_BALANCE_CODE) return null;
    return {
        amount: Number.isFinite(Number(data.amount)) ? Number(data.amount) : undefined,
        balance: Number.isFinite(Number(data.balance)) ? Number(data.balance) : undefined,
        paid: Number.isFinite(Number(data.paid)) ? Number(data.paid) : undefined,
        currency: typeof data.currency === 'string' ? data.currency : undefined
    };
};
